export default __webpack_public_path__ + "static/media/icon.area.d7dcaad5.svg";